import { Disclosure, Popover, Transition } from "@headlessui/react";
import { Icon } from "@iconify/react";
import { Fragment, useState } from "react";
import {
  BlackTextLinearGradient,
  timestampToFormattedDate,
  WhiteLinearGradient,
  WhiteLinearGradientDarkPlain
} from "../../utils/Utils";
import Button from "../basic/Button";
import ShareDialog from "../home/ShareDialog";

function Activity({
  activityImage = "https://www.helpguide.org/wp-content/uploads/resistance-band-woman-doing-leg-workout-768.jpg",
  execisesName,
  date = "",
  exercisesDuration,
  exercisesReps,
  repDuration,
  resultAccuracy,
  resultCoins,
  badgeText,
  exercisesBenefits,
  exerciseURI,
  individualAvgs,
  doneOn,
  url,
  resultURL,
  resultId,
}) {
  const ExerciseAverage = ({ name, percentage }) => {
    return (
      <div className="flex flex-row items-center w-full space-x-5">
        <p className="font-bold text-primary-black dark:text-primary-white flex basis-1/3">
          {name}
        </p>
        <div className="flex flex-1 items-centerw-full bg-primary-extraLightBlue h-3 rounded-md ">
          <div
            style={{
              width: `${percentage}%`,
              background:
                "linear-gradient(270deg, #EA2EFB 2.26%, #450BD5 136.45%)",
              transition: "width 500ms",
            }}
            className=" h-3 rounded-md"
          ></div>
        </div>
        <p className="text-primary-blue dark:text-primary-neonGreen basis-1/6 text-center">
          {percentage}%
        </p>
      </div>
    );
  };

  const [showShareDialog, setShowShareDialog] = useState(false);
  return (
    <div className="mx-auto w-full ">
      <Disclosure>
        {({ open }) => (
          <div
            className={`border-[#B6BCDA80] dark:border-[#68696B33] border-[1px] rounded-xl ${WhiteLinearGradientDarkPlain} px-4 lg:px-7 py-5 `}
          >
            <Disclosure.Button
              className={`w-full text-left flex flex-col flex-1 items-center ${
                individualAvgs && individualAvgs?.length > 0
                  ? "cursor-pointer"
                  : "cursor-default"
              }`}
            >
              <div className="flex flex-1 flex-col md:flex-row md:space-x-3 w-full  lg:space-x-5  h-12 lg:h-24">
                <div className="flex flex-row">
                  <img
                    src={activityImage}
                    className="h-10 lg:h-24 w-20 lg:w-36  rounded-xl bg-white object-cover"
                  />
                  <div className="flex justify-start flex-col ml-3">
                    <p
                      className={`${BlackTextLinearGradient} font-medium lg:text-xl`}
                    >
                      {execisesName}
                    </p>
                    <p className="text-primary-gray font-medium  lg:text-sm">
                      {timestampToFormattedDate(date || doneOn)}
                    </p>
                  </div>
                </div>
                <div className="flex flex-1"></div>
                <div className="flex flex-row space-x-4 justify-center items-center">
                  {exercisesReps != null && (
                    <div className="flex flex-col">
                      <p
                        className={`font-medium text-center  lg:text-xl ${BlackTextLinearGradient}`}
                      >
                        {exercisesReps}
                      </p>
                      <p className="text-primary-gray text-xs lg:text-sm uppercase italic font-medium">
                        Reps.
                      </p>
                    </div>
                  )}
                  {resultAccuracy != null && (
                    <div className="flex flex-col">
                      <p
                        className={`font-medium text-center  lg:text-xl ${BlackTextLinearGradient}`}
                      >
                        {resultAccuracy}%
                      </p>
                      <p className="text-primary-gray text-xs lg:text-sm uppercase italic font-medium">
                        Accuracy
                      </p>
                    </div>
                  )}

                  <ShareDialog
                    show={showShareDialog}
                    close={() => {
                      setShowShareDialog(false);
                    }}
                    shareLink={
                      resultURL
                        ? resultURL
                        : resultId
                        ? `https://app.getactyvphysio.com/results/program/${resultId}`
                        : `https://app.getactyvphysio.com/${exerciseURI}`
                    }
                    shareMessage={`Hey I practiced ${execisesName} on Getactyv today. Do check it out.`}
                  />
                  {!individualAvgs &&
                    typeof individualAvgs == "object" &&
                    !individualAvgs?.length > 0 && (
                      <div className="flex flex-col h-full">
                        <Popover>
                          <Popover.Button>
                            <Icon
                              icon={"carbon:overflow-menu-vertical"}
                              className={`h-6 w-6 text-primary-black dark:text-white place-self-start`}
                            />
                          </Popover.Button>
                          <Transition
                            as={Fragment}
                            enter="transition ease-out duration-200"
                            enterFrom="opacity-0 translate-y-0"
                            enterTo="opacity-100 translate-y-1"
                            leave="transition ease-in duration-150"
                            leaveFrom="opacity-100 translate-y-1"
                            leaveTo="opacity-0 translate-y-0"
                          >
                            <Popover.Panel
                              className={`absolute z-20 w-40 mt-3 -ml-28 focus:outline-none flex flex-col ${WhiteLinearGradient} rounded-xl`}
                            >
                              <div className="flex flex-col">
                                <div
                                  className="flex flex-row space-x-3 hover:bg-primary-white hover:dark:bg-primary-lightBlack p-3 rounded-t-xl"
                                  onClick={() => setShowShareDialog(true)}
                                >
                                  <Icon
                                    icon="ant-design:share-alt-outlined"
                                    className="h-6 w-auto dark:text-white"
                                  />
                                  <p className={`${BlackTextLinearGradient}`}>
                                    Share
                                  </p>
                                </div>

                                <a
                                  href={
                                    url ||
                                    `https://app.getactyvphysio.com/${exerciseURI}`
                                  }
                                >
                                  <div className="flex flex-row space-x-3 hover:bg-primary-white hover:dark:bg-primary-lightBlack p-3 rounded-b-xl">
                                    <Icon
                                      icon="jam:refresh-reverse"
                                      className="h-6 w-auto dark:text-white"
                                    />
                                    <p className={`${BlackTextLinearGradient}`}>
                                      Try Again
                                    </p>
                                  </div>
                                </a>
                              </div>
                            </Popover.Panel>
                          </Transition>
                        </Popover>
                        <div className="flex flex-1"></div>
                      </div>
                    )}
                </div>
              </div>

              <div className="flex flex-row w-full justify-end items-center gap-5 ">
                {(resultURL || resultId) && (
                  <a
                    href={
                      resultURL
                        ? resultURL
                        : `https://app.getactyvphysio.com/results/program/${resultId}`
                    }
                    className="flex self-end mt-5 md:mt-0"
                  >
                    <Button>
                      <p className="text-white">View Result</p>
                    </Button>
                  </a>
                )}
                {individualAvgs &&
                  individualAvgs.length > 0 &&
                  typeof individualAvgs == "object" && (
                    <Icon
                      icon={"akar-icons:chevron-down"}
                      className={`${
                        open ? "rotate-180 transform" : ""
                      } text-primary-black self-center dark:text-white place-self-start`}
                    />
                  )}
              </div>
            </Disclosure.Button>
            <Disclosure.Panel className={"w-full flex flex-col"}>
              {individualAvgs && individualAvgs?.length > 0 && (
                <div className="flfex flex-col md:p-10 space-y-5">
                  <div className="flex flex-row w-full">
                    <p
                      className={`font-medium text-xl text-primary-blue dark:text-primary-neonGreen flex basis-1/3`}
                    >
                      Exercises
                    </p>
                    <div className="flex flex-1"></div>
                    <p
                      className={`font-medium text-xl text-primary-blue dark:text-primary-neonGreen  basis-1/6 text-center`}
                    >
                      Accuracy
                    </p>
                  </div>
                  {individualAvgs?.map((exercise, index) => {
                    return (
                      <ExerciseAverage
                        name={exercise.name}
                        percentage={exercise.per}
                        key={`${exercise.name}-${index}`}
                      />
                    );
                  })}
                </div>
              )}
            </Disclosure.Panel>
          </div>
        )}
      </Disclosure>
    </div>
  );
}

export default function ActivityTimeline({ timeline, className }) {
  return (
    <>
      <div className="space-y-8">
        {Object.keys(timeline).map((key) =>
          timeline[key].map((activity, index) => (
            <Activity {...activity} key={index} />
          ))
        )}
      </div>
    </>
  );
}
